import SysConfig from "./sysConfig.gql";
import SysView from "./systemView.gql";
import SearchDepartment from "./searchDepartment.gql";
import DeviceInfo from "./deviceInfo.gql";
import Captcha from "./captcha.gql";
import {queryHdl} from '../graphqlHdr'


export default {
  // 系统配置
  queryConfig: (vueSelf, variables) => queryHdl.call(vueSelf, SysConfig, variables),
  // 部门
  queryDepartments: (vueSelf, variables) => queryHdl.call(vueSelf, SearchDepartment, variables),
  // 设备信息
  queryDeviceInfo: (vueSelf, variables) => queryHdl.call(vueSelf, DeviceInfo, variables),
  // 视图
  querySysView: (vueSelf) => queryHdl.call(vueSelf, SysView, {}, false),

  // 验证码
  initCaptcha: (vueSelf) => queryHdl.call(vueSelf, Captcha, {}, false),
};
